export const MESSAGES_HEADINGS = {
    MESSAGE_ID: 'message_id',
    RECEIVER_ID: 'receiver_id',
    DATE: 'date',
    TITLE: 'title',
    MESSAGE: 'message',
    SIGNATURE: 'signature',
    CANDIDATE: 'candidate',
  };
  
export const MESSAGES_SETUP_ADMIN = [
  {
    title: MESSAGES_HEADINGS.MESSAGE_ID,
    isSortable: true,
    isHighlighted: true,
    isTextOwerflowHidden: false,
  },
  {
    title: MESSAGES_HEADINGS.DATE,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: false,
  },
  {
    title: MESSAGES_HEADINGS.TITLE,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: false,
  },
  {
    title: MESSAGES_HEADINGS.MESSAGE,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: true,
  },
  {
    title: MESSAGES_HEADINGS.SIGNATURE,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: false,
  },
  {
    title: MESSAGES_HEADINGS.CANDIDATE,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: false,
  },
];

export const MESSAGES_SETUP = [
  {
    title: MESSAGES_HEADINGS.DATE,
    isSortable: true,
    isHighlighted: true,
    isTextOwerflowHidden: false,
  },
  {
    title: MESSAGES_HEADINGS.TITLE,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: false,
  },
  {
    title: MESSAGES_HEADINGS.MESSAGE,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: true,
  },
];

// The PNR search result: one flat list of EVERYTHING a donor received
// (GET /v1/bloodbanks/{id}/donors/{uid}/messages), newest first as served —
// no column sorts. Header labels come from `table.<title>` in the locales.
// No Tittel column: every system message is titled «Blodgiver», so it only
// duplicated Type — an admin message shows its title inside the Melding
// cell instead (helpers.donorMessageCell).
export const DONOR_MESSAGES_HEADINGS = {
  DATE: MESSAGES_HEADINGS.DATE,
  TYPE: 'msg_type',
  SOURCE: 'msg_source',
  MESSAGE: MESSAGES_HEADINGS.MESSAGE,
};

export const DONOR_MESSAGES_SETUP = [
  { title: DONOR_MESSAGES_HEADINGS.DATE, isSortable: false, isHighlighted: true, isTextOwerflowHidden: false },
  { title: DONOR_MESSAGES_HEADINGS.TYPE, isSortable: false, isHighlighted: false, isTextOwerflowHidden: false },
  { title: DONOR_MESSAGES_HEADINGS.SOURCE, isSortable: false, isHighlighted: false, isTextOwerflowHidden: false },
  { title: DONOR_MESSAGES_HEADINGS.MESSAGE, isSortable: false, isHighlighted: false, isTextOwerflowHidden: true },
];

// Server-side sorting of the message history
// (GET /v1/bloodbanks/{id}/messages?sort=&order=): `date` on every tab
// (Firestore timestamp ordering); the admin tab additionally sorts message
// id / signature / candidate count in the API over the bank's admin records.
// Title and body are not sortable (no indexes). `defaultSort` is the order a
// tab loads with — "Planlagt" lists the soonest reminder first.
export const MESSAGES_SORT = {
  admin: {
    defaultSort: { key: MESSAGES_HEADINGS.DATE, order: 'desc' },
    server: [
      MESSAGES_HEADINGS.DATE,
      MESSAGES_HEADINGS.MESSAGE_ID,
      MESSAGES_HEADINGS.SIGNATURE,
      MESSAGES_HEADINGS.CANDIDATE,
    ],
  },
  system: {
    defaultSort: { key: MESSAGES_HEADINGS.DATE, order: 'desc' },
    server: [MESSAGES_HEADINGS.DATE],
  },
  scheduled: {
    defaultSort: { key: MESSAGES_HEADINGS.DATE, order: 'asc' },
    server: [MESSAGES_HEADINGS.DATE],
  },
};

export const messagesSortConfig = (type) => MESSAGES_SORT[type] || MESSAGES_SORT.system;

export const MSG_TITLE_MAX_LENGTH = 100;
export const MSG_BODY_MAX_LENGTH = 900;

export const ALL_BLOOD_TYPES = [
  {rhesus: 'minus', bloodType: 'o'},
  {rhesus: 'plus', bloodType: 'o'},
  {rhesus: 'minus', bloodType: 'a'},
  {rhesus: 'plus', bloodType: 'a'},
  {rhesus: 'minus', bloodType: 'b'},
  {rhesus: 'plus', bloodType: 'b'},
  {rhesus: 'minus', bloodType: 'ab'},
  {rhesus: 'plus', bloodType: 'ab'},
];

export const ABO = [
  { value: 'o', label: 'O' },
  { value: 'a', label: 'A' },
  { value: 'b', label: 'B' },
  { value: 'ab', label: 'AB' },
];

export const Rhd = [
  { value: 'minus', label: '-' },
  { value: 'plus', label: '+' },
];

export const BLOOD_TITER = [
  'low', 'high', 'unknown'
];

export const DONOR_STATUS = [
  'pending', 'new', 'approved', 'established'
];

export const APP_USER_STATUS = [
  'yes', 'no'
];

export const SMS_STATUS = [
  'true', 'false'
];

export const APPOINTMENT_STATUS = [
  'yes', 'no'
];